import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { OrderStorageTypes } from 'swag-common/constants/main-swag.constants';
import { rebuildItem } from 'swag-client-common/redux/cart/cart.actions';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isSuperSpeedColorLimitationPopupShownSelector, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { selectedItemSelector } from '../../../redux/cart/cart.selectors';
import { SuperSpeedColorLimitationPopup as SuperSpeedColorLimitationPopupComponent } from './super-speed-color-limitation-popup';
const colorLimitSelector = createSelector(popupParamsSelector, params => params.maxPrintColors);
const mapStateToProps = createStructuredSelector({
  open: isSuperSpeedColorLimitationPopupShownSelector,
  colorLimit: colorLimitSelector,
  item: selectedItemSelector
});
const mapDispatchToProps = dispatch => ({
  onCancel: item => {
    dispatch(hidePopup());
    dispatch(rebuildItem(item, OrderStorageTypes.CART));
  },
  onConfirm: () => {
    dispatch(hidePopup());
  }
});
export const SuperSpeedColorLimitationPopup = connect(mapStateToProps, mapDispatchToProps)(SuperSpeedColorLimitationPopupComponent);